import { FilterListItem, FilterListItemProps } from 'components/filter/filters-next/FilterListItem';
import { RelationalServerKey } from 'components/filter/types';

const withRelationalServerKey =
    (relationalServerKey?: RelationalServerKey) => (props: FilterListItemProps) => (
        <FilterListItem {...props} relationalServerKey={relationalServerKey} />
    );

export { withRelationalServerKey };
